import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "今日大瓜", path: "/content" },
  { label: "网红翻车", path: "/content/wanghong" },
  { label: "反差视频", path: "/content/fancha" },
  { label: "酒店猛料", path: "/content/jiudian" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-900 whitespace-nowrap">
              51每日大赛
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? "text-primary-500"
                    : "text-foreground-700 hover:text-foreground-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA button */}
          <Link
            to="/content"
            className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-moon-line"></i>
            深夜基地
          </Link>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className={`text-sm font-medium py-2 transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? "text-primary-500"
                    : "text-foreground-700 hover:text-foreground-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/content"
              className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer mt-2"
            >
              <i className="ri-moon-line"></i>
              深夜基地
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}